<template>
  <div class="easypaisa-spinner"></div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@keyframes easypaisa-spin {
  to {
    transform: rotate(360deg);
  }
}

.easypaisa-spinner {
  display: inline-block;
  width: 1.25rem;
  height: 1.25rem;
  vertical-align: middle;
  border: 0.2em solid rgba(30, 33, 40, 0.3);
  border-top-color: #1e2128;
  border-radius: 50%;
  animation: easypaisa-spin 0.75s linear infinite;
}
</style>
